import React from 'react';

function FilterOption({ name, title, id, checked = false, onChange }) {

    const handleClick = () => {
        if (window?.dataLayer) {
            window.dataLayer.push({
                event: 'trends_filter_click',
                value: title,
                page: window.location.pathname,
            });
        }

        onChange(id);
    };

    return (
        <div className="filter-option">
            <input
                className="sr-only"
                type="radio"
                id={id}
                name={name}
                value={id}
                checked={checked}
                onClick={handleClick}
            />
            <label className="filter-btn" htmlFor={id}>
                {title}
            </label>
        </div>
    );
}

export default FilterOption;
